import ResourceService from './resource.service'

class FeatureService extends ResourceService {
  static get resource() {
    return 'vehicle-feature'
  }
}

export default FeatureService
